import {CSSProperties, FC} from 'react';


export interface IIconSettingsProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSettings: FC<IIconSettingsProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M4.812 16A7.856 7.856 0 0 1 4 14.138c.835-.41 1.36-1.236 1.361-2.138 0-.903-.525-1.73-1.36-2.139a7.927 7.927 0 0 1 2.077-3.469 2.57 2.57 0 0 0 2.602.066 2.38 2.38 0 0 0 1.242-2.205 8.595 8.595 0 0 1 4.156.002A2.38 2.38 0 0 0 15.32 6.46a2.57 2.57 0 0 0 2.602-.067A8.029 8.029 0 0 1 20 9.861c-.835.41-1.36 1.236-1.361 2.138 0 .903.525 1.73 1.36 2.139a7.927 7.927 0 0 1-2.077 3.469 2.57 2.57 0 0 0-2.602-.066 2.38 2.38 0 0 0-1.242 2.205 8.594 8.594 0 0 1-4.156-.002A2.38 2.38 0 0 0 8.68 17.54a2.57 2.57 0 0 0-2.602.067 8.05 8.05 0 0 1-1.266-1.608Zm4.698.156a4.028 4.028 0 0 1 1.867 2.216c.415.037.83.038 1.245 0a4.028 4.028 0 0 1 1.868-2.215 4.28 4.28 0 0 1 2.926-.452c.24-.326.448-.674.62-1.038A3.912 3.912 0 0 1 16.98 12c0-1.008.39-1.95 1.057-2.667a6.438 6.438 0 0 0-.623-1.038 4.28 4.28 0 0 1-2.924-.451 4.028 4.028 0 0 1-1.867-2.216 6.878 6.878 0 0 0-1.245 0A4.028 4.028 0 0 1 9.51 7.843a4.28 4.28 0 0 1-2.926.452c-.24.327-.448.674-.62 1.038A3.912 3.912 0 0 1 7.02 12a3.91 3.91 0 0 1-1.057 2.667c.174.364.382.711.623 1.038a4.28 4.28 0 0 1 2.924.451ZM12 14.4c-1.375 0-2.49-1.075-2.49-2.4S10.625 9.6 12 9.6c1.375 0 2.49 1.075 2.49 2.4s-1.115 2.4-2.49 2.4Zm0-1.6c.458 0 .83-.358.83-.8 0-.442-.372-.8-.83-.8-.458 0-.83.358-.83.8 0 .442.372.8.83.8Z" clipRule="evenodd" />
        </svg>
    );
};
